import { createElement, Fragment, useCallback } from "react";

import { type IntlShape, useIntl } from "react-intl";

import messages from "../locales/messages";

const useTranslation = () => {
  const intl = useIntl();
  const m = messages;

  // Wrap rich-text array results with keyed fragments so callers can render the
  // result directly (e.g. `{t(...)}`) without React 19 warning about missing
  // keys on array children. The primitive-values overload still returns string.
  const t = useCallback(
    ((descriptor, values, opts) => {
      const result = intl.formatMessage(descriptor, values, opts);
      if (Array.isArray(result)) {
        return result.map((node, i) => createElement(Fragment, { key: i }, node));
      }
      return result;
    }) as IntlShape["formatMessage"],
    [intl]
  );

  /**
   * Formats a date string using the current locale.
   * Example: "January 15" (en) or "15 de janeiro" (pt-BR)
   */
  const formatDate = useCallback(
    (date: string | Date, options?: Intl.DateTimeFormatOptions) => {
      const defaultOptions: Intl.DateTimeFormatOptions = {
        day: "numeric",
        month: "long",
      };
      return intl.formatDate(date, options ?? defaultOptions);
    },
    [intl]
  );

  return {
    t,
    m,
    formatDate,
  };
};

export default useTranslation;
